import { ReactNode, useEffect, useRef } from "react";
import CSS from "./static/css/AccountPage.module.css";
import { useCommonStore } from "../../../../App";

const AccountPage = (
    {
        children
    }:{
        children?: ReactNode;
    }
) => {
    const setIsNaviHidden = useCommonStore((state) => state.setIsNaviHidden);
    const setIsHeaderHidden = useCommonStore((state) => state.setIsHeaderHidden);

    useEffect(() => {
        setIsNaviHidden(true);
        setIsHeaderHidden(true);

        return () => {
            setIsNaviHidden(false);
            setIsHeaderHidden(false);
        }
    }, []);

    return(
        <div className={CSS.l_AccountPage_main}>
            {children}
        </div>
    )
}

export default AccountPage;